import whatsNewTpl from 'templates/__whatsNew.tpl';
import noDataTpl from 'templates/__noData.tpl';
import castTpl from 'templates/__cast.tpl';
import defaultTpl from 'templates/__gridView.tpl';
import showNewsTpl from 'templates/__showNews.tpl';
import showPhotosTpl from 'templates/__showPhotos.tpl';
import showAlbumsTpl from 'templates/__showAlbums.tpl';
import Breakpoints from 'helpers/breakpoints';
import 'carousels/helpers/ellipsify';
import SeasonDropdownFilter from 'components/dropdownFilters/DropdownFilter';
import { formatDate, formatTimeElements } from '../helpers/dates';

export default function (customOptions = {}) {
    let templates = {
        whatsNewTpl: whatsNewTpl,
        showNewsTpl: showNewsTpl,
        showPhotosTpl: showPhotosTpl,
        showAlbumsTpl: showAlbumsTpl,
        castTpl: castTpl,
        noDataTpl: noDataTpl,
        defaultTpl: defaultTpl,
    };

    let template = customOptions.useTemplate ? templates[customOptions.useTemplate] : defaultTpl;
    let noDataMessage = customOptions.options.noDataMessage
        ? customOptions.options.noDataMessage
        : 'No data available.';
    let noResizeListener = customOptions.options.noResizeListener
        ? customOptions.options.noResizeListener
        : false;

    let parentContainer = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('#latest-episodes');
    let container = parentContainer.find('.grid-view-container');
    let btnLoadMore = parentContainer.find('.js-load-more');
    let btnLoadMoreText = btnLoadMore.find('.button__text');
    let btnLoadMoreCopy = btnLoadMoreText.text();
    let svgLoader = parentContainer.find('.grid-view-svg-loader');
    let b = new Breakpoints();
    let currentBreakpoint = b.getCurrentBreakpointName();
    let currentLatestEpisodesPage = 0;
    let isFirstLoad = true;
    let hasResized = false;
    let list = [];
    let currentIdx = 0;
    let currentArticleHeight = 0;
    let season = parentContainer.data('season');
    let currentParams = null;
    let filters = null;
    let total = null;

    let loadSizes = {
        desktopWide: 18,
        desktop: 10,
        tabletLandscape: 8,
        tabletPortrait: 6,
        mobileLandscape: 4,
        mobilePortrait: 4,
    };

    let displayPerRowByBreakpoint = {
        mobilePortrait: 1,
        mobileLandscape: 2,
        tabletPortrait: 3,
        tabletLandscape: 4,
        desktop: 5,
        desktopWide: 6,
    };

    let rowsByBreakpoint = {
        mobilePortrait: 4,
        mobileLandscape: 2,
        tabletPortrait: 2,
        tabletLandscape: 2,
        desktop: 2,
        desktopWide: 2,
    };

    let toggleSvgLoader = function () {
        if (!isFirstLoad) {
            if (isLoading()) {
                btnLoadMore.find('svg').remove();
                btnLoadMoreText.text(btnLoadMoreCopy);
            } else {
                let svg = svgLoader.clone().css({
                    display: 'block',
                });
                btnLoadMore.append(svg);

                // clear text & prevents page jank
                btnLoadMoreText.html('&nbsp;');
            }
        }
    };

    let boot = function () {
        if ($('.js-load-more')[0]) {
            currentIdx = getLoadSize() > 12 ? 11 : getLoadSize() - 1;
            while (
                container.find('article.grid-view-item').length >
                loadSizes[b.getCurrentBreakpointName()]
            ) {
                let articles = container.find('article.grid-view-item');
                $(articles[articles.length - 1]).remove();
            }
            // set local total & hide Load More if all videos listed
            total = container.data('total');
            hideLoadMoreIfAllLoaded();
        }

        // FILTERS
        if (parentContainer.find('.js-dropdown').length > 0) {
            filters = new SeasonDropdownFilter();
            filters.setMount(parentContainer.find('.js-dropdown')).build();

            season = filters.options[filters.selectedInd].value;

            __killDropdownAnimHack();

            $(filters).on('filterSelected', (e, index, value) => {
                if (customOptions.onFilterSelected) {
                    customOptions.onFilterSelected(value);
                }

                __killDropdownAnimHack();

                currentLatestEpisodesPage = 0;
                season = value;

                isFirstLoad = true;
                total = null;
                // hasResized = false;
                list = [];
                currentIdx = 0;
                let f = function () {
                    removeAll();
                    loadListFromIndex(0, getLoadSize(), true);
                    hideLoadMoreIfAllLoaded();
                };
                getEpisodes(f);
            });

            $(filters).on('episodes-ready', (e) => {
                let hoverMount = parentContainer.find('.js-dropdown').find('li.pv-h-disable');
                hoverMount.removeClass('pv-h-disable');
            });
        }
    };

    let __killDropdownAnimHack = function () {
        let hoverMount = parentContainer.find('.js-dropdown').find('li.pv-h');
        hoverMount.addClass('pv-h-disable');
    };

    let isLoading = function () {
        return btnLoadMore.has('svg').length > 0;
    };

    let getRowsByBreakpoint = function () {
        return rowsByBreakpoint[b.getCurrentBreakpointName()];
    };

    let getPerRow = function () {
        return displayPerRowByBreakpoint[b.getCurrentBreakpointName()];
    };

    //getLoadSize is used to know how many to put into the dom
    let getLoadSize = function () {
        if ($('.js-load-more')[0]) {
            return loadSizes[b.getCurrentBreakpointName()];
        } else {
            return 50;
        }
    };

    //getLimitSize is used to get how many to retrieve from api
    let getLimitSize = function () {
        if ($('.js-load-more')[0]) {
            return 18;
        } else {
            return 50;
        }
    };

    let getEpisodes = function (callback) {
        toggleSvgLoader();

        let limit = getLimitSize();
        let endpoint = buildEndpoint({
            page: currentLatestEpisodesPage,
            season: season,

            // clips grid xhr request uses these params
            offset: currentLatestEpisodesPage * limit,
            limit: limit,
        });

        if (!isFirstLoad && limit >= total) {
            loadListFromIndex(currentIdx + 1, total, true);
            toggleSvgLoader();
        } else {
            formatTimeElements(container[0]);
            $.ajax({
                type: 'GET',
                url: endpoint,
                dataType: 'json',
                success: function (resp) {
                    toggleSvgLoader();
                    if (total === null) {
                        setTotal(resp.result.total);
                    }
                    appendList(resp);
                    if (callback) {
                        callback();
                    } else {
                        handleSuccess(resp);
                    }
                    if (resp?.result?.data?.length === 0) {
                        hideLoadMoreIfAllLoaded(true);
                    }
                },
            });
        }
    };

    let focusFirstLoadedItem = function (startOfBatchIndex) {
        let link = container.find('article:eq(' + startOfBatchIndex + ') a:eq(0)');
        if (link.length > 0) {
            $(link).focus();
        }
    };

    let buildEndpoint = function (merge) {
        let params = $.extend(currentParams, merge);

        if (currentParams === null) {
            // default params
            currentParams = {
                slug: parentContainer.data('slug'),
                page: currentLatestEpisodesPage,
                size: getLimitSize(),
                excludeShow: 0,
                season: season,
            };

            params = $.extend(currentParams, customOptions.options.params, merge);
        }

        currentParams = params;

        let endpoint = customOptions.options.endPoint;
        for (let property in params) {
            if (params.hasOwnProperty(property)) {
                endpoint = endpoint.replace('{' + property + '}', params[property]);
            }
        }

        return endpoint;
    };

    let appendList = function (resp) {
        resp.result.data.forEach((obj) => {
            list.push(obj);
        });
    };

    let handleSuccess = function () {
        if (isFirstLoad) {
            handleFirstLoad();
        } else {
            handleAnotherLoad();
        }
    };

    let handleFirstLoad = function () {
        if (hasResized) {
            removeAll();
            loadListFromIndex(0, null, false);
        } else {
            notifyFilterReadyForInteraction();
        }
    };

    let removeAll = function () {
        container.find('article.grid-view-item').remove();
    };

    let handleAnotherLoad = function () {
        let startOfNewBatch = currentIdx + 1;
        loadListFromIndex(currentIdx + 1, null, true);
        focusFirstLoadedItem(startOfNewBatch);
    };

    let handleResize = function () {
        hasResized = true;
        setProgressBarAlreadyRendered();
        let resizedBreakpoint = b.getCurrentBreakpointName();
        if (currentBreakpoint !== resizedBreakpoint) {
            currentBreakpoint = resizedBreakpoint;
            if (isFirstLoad) {
                handleFirstLoad();
            } else {
                reloadAll();
            }
            hideLoadMoreIfAllLoaded();
        }
    };

    let setProgressBarAlreadyRendered = function () {
        list.forEach((item, idx) => {
            if (!item.hasRendered) {
                item.hasRendered = true;
            }
        });
    };

    let reloadAll = function () {
        removeAll();
        loadListFromIndex(0, list.length, false);
    };

    const localizeAirDates = function (item) {
        if (!item.airdate_iso) return;

        item.airdate = formatDate(item.airdate_iso);
    };

    let loadListFromIndex = function (from, to, doAnimation) {
        doAnimation = doAnimation === true;

        // fill dom
        let opacity = doAnimation === true ? 0 : 1;
        let max = to ? to : from + getLoadSize();

        if (list.length > 0) {
            for (let i = from; i < max && i < total; i++) {
                if (typeof list[i] !== 'undefined') {
                    currentIdx = i;
                    localizeAirDates(list[i]);
                    container.append(
                        $(template(list[i])).css({
                            opacity: opacity,
                        }),
                    );
                }
            }
        } else {
            container.append(
                $(templates.noDataTpl())
                    .css({
                        opacity: opacity,
                    })
                    .text(noDataMessage),
            );
        }

        if (CBS.Registry.lazyImage) {
            setTimeout(() => {
                CBS.Registry.lazyImage.revalidate();
            }, 200);
        }

        // fill holes if necessary

        let totalArticles = container.find('article.grid-view-item').length;
        let needsMore = totalArticles % getPerRow() !== 0 && max < total;

        if (doAnimation) {
            animateContainer();
        }

        if (needsMore) {
            handleNeedsMore();
        } else {
            container.ellipsify();
            // TODO: consider deleting if not needed
            hideLoadMoreIfAllLoaded();
            notifyFilterReadyForInteraction();
        }
    };

    let animateContainer = function () {
        let _getGap = function () {
            let gap;

            // chrome
            if (!gap) {
                gap = container.css('gap');
                if (gap) {
                    gap = parseInt(gap.split(' ')[0]);
                }
            }

            // firefox
            if (!gap) {
                gap = container.css('row-gap');
                if (gap) {
                    gap = gap.replace('px', '');
                }
            }

            // safari
            if (!gap) {
                gap = container.css('grid-gap');
                if (gap) {
                    gap = parseInt(gap.replace('/ ', ''));
                }
            }

            // no gap found
            if (!gap) {
                gap = 0;
            }

            return gap;
        };

        // prep to animate container
        container.css({
            height: container.height(),
        });

        currentArticleHeight = 0;
        let articles = container.find('article');
        articles.each(() => {
            let h = $(this).height();
            if (h > currentArticleHeight) {
                currentArticleHeight = h;
            }
        });

        let rows = getRowsByBreakpoint();
        let increase = currentArticleHeight * rows + _getGap();

        // animate grid container
        container.animate(
            {
                height: container.height() + increase,
            },
            300,
            () => {
                // set grid back to auto to adjust (this is in case there's only 1 line of copy for the title across row 1 OR 2, so there's proper spacing below grid container)
                container.css({
                    height: 'auto',
                });

                // fade in grid items
                container
                    .find('article')
                    .delay(300)
                    .animate(
                        {
                            //
                            opacity: 1,
                        },
                        300,
                        () => {
                            // animate Load More button
                            hideLoadMoreIfAllLoaded();
                        },
                    );
            },
        );
    };

    let handleNeedsMore = function () {
        let currentEpisodesCount = container.find('article.grid-view-item').length;
        let perRow = getPerRow();
        let remainder = currentEpisodesCount % getPerRow();
        let numMore = perRow - remainder;

        if (numMore > 0) {
            let from = currentIdx + 1;
            let to = currentIdx + numMore + 1;
            let f = function () {
                // was false, testing smoothness
                loadListFromIndex(from, to, true);
            };

            if (currentEpisodesCount + numMore <= list.length) {
                f();
            } else {
                currentLatestEpisodesPage++;
                getEpisodes(f);
            }
        }
    };

    let setTotal = function (tot) {
        total = tot;
        container.data('total', tot);
    };

    let hideLoadMoreIfAllLoaded = function (forceHide = false) {
        // hide load more button when total episodes are displayed
        let l = container.find('article').length;

        if (container.find('.grid-view-item.noData').length) {
            forceHide = true;
        }

        if ((container.find('article').length === total && total !== 0) || forceHide) {
            //btnLoadMore.parent().remove();
            btnLoadMore
                .parent()
                .addClass('load-more-container-hidden')
                .removeClass('load-more-container-show');
        } else {
            btnLoadMore
                .parent()
                .removeClass('load-more-container-hidden')
                .addClass('load-more-container-show');
        }
    };

    let notifyFilterReadyForInteraction = function () {
        $(filters).trigger('episodes-ready');
    };

    let trackingLoadMoreBtn = function () {
        try {
            if (typeof om != 'undefined') {
                om.trackClick({
                    item: btnLoadMore.attr('aa-link'),
                });
            }
        } catch (e) {}
    };

    let trackingGridItem = function ($target) {
        var aaLink = $target.attr('aa-link').split('|');

        let rowHeaderTitle = aaLink[0];
        var showEpisodeLabel = aaLink[5];
        var showEpisodeId = aaLink[16];
        var showSeriesId = aaLink[11] !== '' ? aaLink[11] : (CBS.Registry.Show.id ?? '');
        var showBrand = aaLink[10];
        var showGenre = aaLink[15];
        let contentLocked = aaLink[23];
        let posColNum = (Number(aaLink[3]) - 1).toString();
        let showSeriesTitle = aaLink[4];

        var loc = window.location.href;
        var action = loc.indexOf('shows') > -1 ? 'trackShowContent' : 'trackRowHeader';
        let obj = null;

        obj = {
            showEpisodeLabel: showEpisodeLabel,
            showEpisodeTitle: showEpisodeLabel,
            showEpisodeId: showEpisodeId,
            showSeriesId: showSeriesId,
            showSeasonNumber: aaLink[6].toString(),
            showEpisodeNumber: aaLink[7].toString(),
            contentBrand: showBrand,
            showGenre: showGenre,
            showSeriesTitle: showSeriesTitle,
            posColNum,
            rowHeaderTitle,
            contentLocked,
        };

        if (CBS.Registry.kidsLanding) {
            action = 'trackContentGridSelect';
            obj.showBrowseCategory = null;
        }

        obj[aaLink[13] === 'p' ? 'PPlusSubscriberBadge' : 'TVELockedBadge'] = aaLink[14];
        obj.posRowNum = getCurrentPageRowPosition($target).toString();

        //START A/B TEST PLGRWEB-1657-Fav Five Seasons
        if (CBS.AbTestsConfigs?.modules?.ShowPageFanFaveSeasons?.inVariants) {
            obj.carouselContentType = 'show';
            obj.contentLocked = contentLocked !== '1' ? '0' : contentLocked.toString();
        }
        //END A/B TEST PLGRWEB-1657-Fav Five Seasons

        try {
            if (typeof om != 'undefined') {
                om.trackAction(action, obj);
            }
        } catch (e) {
            console.error(action + ' failed to load');
        }
    };

    let getCurrentPageRowPosition = function ($item) {
        let mainComponents = $('.hero__wrapper, .grid-view, .js-le-carousel');
        let itemMainParent = $item.parents('.grid-view');

        let position = null;
        mainComponents.each(function (index, element) {
            let $element = $(element);
            if ($element.html() === itemMainParent.html()) {
                position = index;
            }
        });

        return position;
    };

    if (parentContainer.length > 0) {
        $(document).ready(function () {
            getEpisodes();

            document.getElementsByClassName('js-load-more').tabIndex = '0';

            btnLoadMore.on('click', (e) => {
                e.preventDefault();
                isFirstLoad = false;
                if (!isLoading()) {
                    let divsCount = document.getElementsByClassName('grid-view-item').length;
                    currentLatestEpisodesPage++;
                    getEpisodes();
                    trackingLoadMoreBtn();
                    let articleDiv =
                        document.getElementsByClassName('grid-view-item')[divsCount - 1];
                    articleDiv.querySelector('a').focus();
                }
            });
            if (!noResizeListener) {
                window.addEventListener('resize', handleResize);
            }

            $(container).on('click', '.grid-view-item a', function (e) {
                e.preventDefault();
                trackingGridItem($(this));
                location.href = $(this).attr('href');
            });
        });

        boot();
    }
}
